import React from "react";

const EventNameInput = ({ eventName, onChange }) => (
  <div>
    <label className="block font-medium text-gray-700 mb-1">Event Name</label>
    <input
      type="text"
      placeholder="Enter name of event..."
      value={eventName}
      onChange={(e) => onChange("eventName", e.target.value)}
      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
);

export default EventNameInput;
